var _g, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveVerificationAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 45C0 20.1472 20.1472 0 45 0C69.8528 0 90 20.1472 90 45C90 69.8528 69.8528 90 45 90C20.1472 90 0 69.8528 0 45Z",
    fill: "#F9A000",
    fillOpacity: 0.2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 69,
    height: 69,
    rx: 34.5,
    fill: "#F9A000",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 33.333C53.824 33.333 60.167 39.676 60.167 47.5C60.167 55.324 53.824 61.667 46 61.667C38.176 61.667 31.833 55.324 31.833 47.5C31.833 39.676 38.176 33.333 46 33.333ZM46 38.75C45.3096 38.75 44.75 39.3096 44.75 40V46.1699C44.0033 46.6023 43.5001 47.4082 43.5 48.333C43.5 49.7137 44.6193 50.833 46 50.833C47.3807 50.833 48.5 49.7137 48.5 48.333C48.4999 47.4082 47.9967 46.6023 47.25 46.1699V40C47.25 39.3096 46.6904 38.75 46 38.75ZM46 29C47.8263 29 49.5953 29.2532 51.2725 29.7275C51.8037 29.8779 52.112 30.4306 51.9619 30.9619C51.8116 31.4934 51.259 31.8027 50.7275 31.6523C49.2259 31.2276 47.6403 31 46 31C44.3597 31 42.7741 31.2276 41.2725 31.6523C40.741 31.8027 40.1884 31.4934 40.0381 30.9619C39.888 30.4306 40.1963 29.8779 40.7275 29.7275C42.4047 29.2532 44.1737 29 46 29Z",
    fill: "#F9A000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveVerificationAccount);
export default __webpack_public_path__ + "static/media/active_verification_account.e9f51e5aca7f35f680daaff8dc7947ca.svg";
export { ForwardRef as ReactComponent };